export function initTabs({headerSelectedClass = 'tab-header-selected', paneSelectedClass = 'tab-pane-selected'} = {}) {
    for (const container of document.querySelectorAll('.tabs')) {
        /** @type {NodeListOf<HTMLButtonElement>} */
        const headers = container.querySelectorAll('.tab-header');
        /** @type {NodeListOf<HTMLDivElement>} */
        const panes = container.querySelectorAll('.tab-pane');
        for (const header of headers) {
            const paneId = header.getAttribute('aria-controls');
            /** @type {HTMLDivElement} */
            const pane = container.querySelector(`#${paneId}`);

            header.addEventListener('click', () => {
                for (const otherHeader of headers) {
                    const isSelected = header === otherHeader;
                    otherHeader.ariaSelected = isSelected.toString();
                    otherHeader.tabIndex = isSelected ? 0 : -1;
                    otherHeader.classList.toggle(headerSelectedClass, isSelected);
                }
                for (const otherPane of panes) {
                    otherPane.classList.toggle(paneSelectedClass, pane === otherPane);
                }
            });

            header.addEventListener('keydown', e => {
                let target;
                switch (e.code) {
                    case 'ArrowUp':
                    case 'ArrowRight':
                        target = header.nextElementSibling;
                        break;
                    case 'ArrowDown':
                    case 'ArrowLeft':
                        target = header.previousElementSibling;
                        break;
                }

                if (target && target.classList.contains('tab-header')) {
                    target.focus();
                    for (const otherHeader of headers) {
                        otherHeader.tabIndex = target === otherHeader ? 0 : -1;
                    }
                }
            });
        }
    }
}
